export interface StoreLabel {
  code: string;
  name: string;
}

export interface StoreCatalogItem {
  storeCode: string;
  name: string;
}

/**
 * Nome da loja para a lista. Usa o que a API já resolveu; se o join por
 * `storeCod` veio vazio, cruza `storeCodes` com as lojas já carregadas na tela.
 */
export function linkedStores(
  resolved: StoreLabel[] | null | undefined,
  storeCodes: string[] | null | undefined,
  catalog: StoreCatalogItem[],
): StoreLabel[] {
  if (resolved && resolved.length > 0) return resolved;

  const seen = new Set<string>();
  const rows: StoreLabel[] = [];
  for (const raw of storeCodes ?? []) {
    const token = String(raw ?? '').trim();
    if (!token || seen.has(token)) continue;
    seen.add(token);
    const byCode = catalog.find((store) => store.storeCode === token);
    if (byCode) {
      rows.push({ code: byCode.storeCode, name: byCode.name || byCode.storeCode });
      continue;
    }
    const byName = catalog.find((store) => store.name.trim().toLowerCase() === token.toLowerCase());
    if (byName) {
      rows.push({ code: byName.storeCode, name: byName.name || token });
      continue;
    }
    rows.push({ code: token, name: token });
  }
  return rows;
}
